import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Grid from '@mui/material/Grid';
import { useEffect, useMemo } from 'react';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';

import GroupedTableView from 'core/table/GroupedTableView';
import FallbackImageLoader from 'core/fallbackLoader/FallbackImageLoader';

import { getLicensingPartner } from 'app/features/licensing-partners/licensingPartnerSaga';

const isValidUrl = (string) => {
  try {
    let url = new URL(string);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch (error) {
    return false;
  }
};

const TextFlowWrapper = styled(Typography)(({ theme }) => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '62rem',
  fontWeight: '400',
  fontSize: '14px',
}));

export default function LicensingPartner({ licensingPartnerId }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLicensingPartner(licensingPartnerId));
  }, [licensingPartnerId]);

  const viewLicensingPartnerData = useMemo(() => [
    {
      groupName: '',
      groupData: [
        {
          label: 'Licensing Partner ID',
          data: 'id',
        },
        {
          label: 'Name',
          data: 'name',
        },
        {
          label: 'Licensing Number',
          data: 'license_number',
          get: ({ license_number }) => <TextFlowWrapper>{license_number}</TextFlowWrapper>,
        },
        {
          label: 'Logo',
          data: 'logo',
          get: ({ logo }) => <FallbackImageLoader imageUrl={logo} />,
        },
        {
          label: 'Privacy Policy',
          data: 'privacy_policy_link',
          get: ({ privacy_policy_link }) => (
            <TextFlowWrapper>{privacy_policy_link}</TextFlowWrapper>
          ),
        },
        {
          label: 'Terms and Conditions',
          data: 'terms_and_conditions_link',
          get: ({ terms_and_conditions_link }) => (
            <TextFlowWrapper>{terms_and_conditions_link}</TextFlowWrapper>
          ),
        },

        {
          label: 'Created At',
          data: 'created_ts',
        },
        {
          label: 'Updated At',
          data: 'updated_ts',
        },
      ],
    },
  ]);

  const { isLoading, data: LicensingPartners } = useSelector(
    (state) => state.licensingPartners.show,
  );

  return (
    <Grid container spacing={2}>
      {viewLicensingPartnerData?.map((group, i) => (
        <GroupedTableView
          key={i}
          title={group.groupName}
          data={group.groupData}
          item={LicensingPartners}
          isLoading={isLoading}
        />
      ))}
    </Grid>
  );
}

LicensingPartner.propTypes = {
  licensingPartnerId: PropTypes.string,
};